import styles from "./App.module.css";

function App() {
  return (
    <div className={styles.app}>
      <br />
      <img
        src="lain-serial-experiments-lain.gif"
        alt="lain gif"
        className={styles.lainGif}
      />
    </div>
  );
}

export default App;
